<!-- SubscriptionForm.svelte -->
<script>
    let email = '';
    let name = '';
    let message = '';
    const endpoint = 'https://x2hfof4qrh.execute-api.us-east-1.amazonaws.com/production';

    const submitForm = async () => {
        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, name, message: 'Get started now' }),
            });

            if (response.ok) {
                message = "Thank you! We'll send on our guide shortly.";
                email = '';
                name = '';
            } else {
                message = 'Something went wrong. Please try again.';
            }
        } catch (error) {
            message = 'Error connecting to the server. Please try again later.';
        }
    };

    const handleSubmit = () => {
        submitForm();
    };
</script>

<div class="container">
    <h1>Sign Up Now</h1>
    <p>We'll email you our Solana trading guide.</p>
    <input
        type="text"
        bind:value={name}
        placeholder="Enter your name"
        required
    />
    <input
        type="email"
        bind:value={email}
        placeholder="Enter your email"
        required
    />
    <button on:click={handleSubmit}>Submit</button>
    {#if message}
        <div class="message">{message}</div>
    {/if}
</div>

<style>
    .container {
        background-color: #fff;
        padding: 2rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        margin-bottom: 2rem;
    }

    h1 {
        margin-bottom: 1rem;
        color: #800020;
        font-family: "Bungee Tint", sans-serif;
        font-weight: 400;
        font-style: normal;
    }

    input[type="text"],
    input[type="email"] {
        width: 100%;
        padding: 0.75rem;
        margin-bottom: 1rem;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 1rem;
    }

    button {
        background-color: #0070f3;
        color: #fff;
        padding: 0.75rem;
        border: none;
        border-radius: 4px;
        font-size: 1rem;
        cursor: pointer;
        width: 100%;
    }

    button:hover {
        background-color: #005bb5;
    }

    .message {
        margin-top: 1rem;
        color: #0070f3;
    }
</style>
